<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row class="fill-height" align="center" justify="center">
      <v-col>
        <v-row>
          <v-col align="center" justify="center" cols="12">
            <v-card class="slide-card" style="max-width: 90%;">
              <v-img src="../../public/static/Campbellton Logo.jpg" contain width="50%" />
              <div class="slide-content text-center">
                <h2>
                  Email us: <br />
                  <a href="mailto:publichearinginfo@itsmarta.com"
                    alt="marta email address">publichearinginfo@itsmarta.com</a>
                  <br />
                  <a href="mailto:marnold-vhb@itsmarta.com">marnold-vhb@itsmarta.com</a>
                </h2>
                <br />
                <p style="margin-bottom:0px;">
                  We're on all major social media platforms. <br />
                  Share your contact information with us to receive the most
                  recent project information. <br /><br />
                  <Subscribe /><br />
                  Join us at future meetings and share news with your friends
                  and neighbors. <br /><br />
                </p>
                <!-- <br />
                <p>
                  Click the TV screen icon to watch a recording of the February 3<sup>rd</sup> and 5<sup>th</sup>
                  live virtual meeting.
                </p> -->
              </div>
              <v-row class="centered" style="padding-bottom:3rem;">
                <v-col :cols="columnsIcons">
                  <v-btn icon class="centered" @click="goTo('web')">
                    <v-icon x-large class="icon-link">
                      fas fa-globe
                    </v-icon>
                  </v-btn>
                  <v-row class="centered">
                    <span class="icon-text">Website</span>
                  </v-row>
                </v-col>
                <v-col :cols="columnsIcons">
                  <v-btn icon class="centered" @click="goTo('facebook')">
                    <v-icon x-large class="icon-link">
                      fab fa-facebook
                    </v-icon>
                  </v-btn>
                  <v-row class="centered">
                    <span class="icon-text">Facebook</span>
                  </v-row>
                </v-col>
                <v-col :cols="columnsIcons">
                  <v-btn icon class="centered" @click="goTo('twitter')">
                    <v-icon x-large class="icon-link">
                      fab fa-twitter
                    </v-icon>
                  </v-btn>
                  <v-row class="centered">
                    <span class="icon-text">Twitter</span>
                  </v-row>
                </v-col>
                <v-col :cols="columnsIcons">
                  <v-btn icon class="centered" @click="goTo('insta')">
                    <v-icon x-large class="icon-link">
                      fab fa-instagram
                    </v-icon>
                  </v-btn>
                  <v-row class="centered">
                    <span class="icon-text">Instagram</span>
                  </v-row>
                </v-col>
                <v-col :cols="columnsIcons">
                  <v-btn icon class="centered" @click="doctoggled = true">
                    <v-icon large class="icon-link">
                      far fa-file
                    </v-icon>
                  </v-btn>
                  <v-row class="centered">
                    <span class="icon-text">Documents</span>
                  </v-row>
                </v-col>
                <!-- <v-col :cols="columnsIcons">
                  <v-btn icon class="centered" @click="goTo('factSheet')">
                    <v-icon large class="icon-link">fa-question-circle</v-icon>
                  </v-btn>
                  <v-row class="centered"
                    ><span class="icon-text">Factsheet</span></v-row
                  >
                </v-col> -->
                <v-col :cols="columnsIcons">
                  <v-btn icon class="centered" @click="meetingstoggled = true">
                    <v-icon large class="icon-link">
                      fas fa-tv
                    </v-icon>
                  </v-btn>
                  <v-row class="centered">
                    <span class="icon-text">Meetings</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="doctoggled" :width="modalWidth">
      <v-sheet width="100%">
        <v-list>
          <v-list-item-group color="blue">
            <v-subheader style="font-size: 2rem;">
              DOCUMENTS
            </v-subheader>
            <v-list-item v-for="pdf in documentpdfs" :key="pdf.name">
              <a :href="getFile(pdf.link, pdf.type)" target="_blank" style="width: 100%; text-decoration: none !important;">
                <v-list-item-content>
                  <v-list-item-title><span id="doc-name">{{
                      pdf.name
                  }}</span></v-list-item-title>
                </v-list-item-content>
              </a>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-sheet>
    </v-dialog>
    <v-dialog v-model="meetingstoggled" :width="modalWidth">
      <v-sheet width="100%">
        <v-list>
          <v-list-item-group color="blue">
            <v-subheader style="font-size: 2rem;">
              MEETINGS
            </v-subheader>
            <v-list-item v-for="pdf in meetinglinks" :key="pdf.name">
              <a :href="pdf.link" target="_blank" style="width: 100%; text-decoration: none !important;">
                <v-list-item-content>
                  <v-list-item-title><span id="doc-name">{{
                      pdf.name
                  }}</span></v-list-item-title>
                </v-list-item-content>
              </a>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-sheet>
    </v-dialog>
  </v-sheet>
</template>

<script>
import Subscribe from "@/components/mailchimp/Subscribe";

export default {
  name: "StayEngaged",
  components: {
    Subscribe
  },
  data: () => ({
    showVideoDialog: false,
    doctoggled: false,
    meetingstoggled: false,
    meetinglinks: [
      {
        name: "Virtual Public Meeting – June 10, 2021",
        link: "https://www.youtube.com/watch?v=oQ-5HZpb5Os"
      },
      {
        name: "Virtual Public Meeting – February 3, 2022",
        link: "https://www.youtube.com/watch?v=J9EcWROldGQ"
      },
      {
        name: "Virtual Public Meeting – February 5, 2022",
        link: "https://www.youtube.com/watch?v=hqOxQcgpGsU"
      },
      {
        name: "In-Person Public Meeting – March 31, 2022",
        link: "https://www.youtube.com/watch?v=NCKxPsiZiVo"
      }],
    documentpdfs: [
      {
        name: "MARTA Response to Atlanta City Council Resolution",
        link: "MARTA+Response+to+Atlanta+City+Council+Resolution",
        type: "pdf"
      },
      {
        name: "Project Kickoff--November 19, 2019",
        link: "Campbellton November 2019 Presentation",
        type: "pdf"
      },
      {
        name: "Virtual Public Meeting--June 25, 2020",
        link: "Campbellton June 25 2022 Presentation",
        type: "pdf"
      },
      {
        name: "Virtual Public Meeting--June 10, 2021",
        link: "Campbellton June 10 2022 Presentation",
        type: "pdf"
      },
      {
        name: "Virtual Public Meetings—Feb. 3 and 5, 2022",
        link: "Campbellton February 2022 Presentation",
        type: "pdf"
      },
      {
        name: "In-Person Public Meeting—March 31, 2022",
        link: "Campbellton March 2022 Presentation",
        type: "pdf"
      },
      {
        name: "In-Person Public Meeting May 21, 2022",
        link: "LPAEducationKit",
        type: "pdf"
      },
      {
        name: "In-Person Public Meeting – June 28, 2022",
        link: "Community development roundtable slide deck",
        type: "pdf"
      },
      {
        name: "In-Person Mt. Carmel Community Meeting - July 28, 2022",
        link: "https://campbellton-files.s3.us-east-2.amazonaws.com/Campbellton+CIC_Mt.+Carmel+Presentation+072122+DRAFT_v2r1.pptx",
        type: "url"
      },
      {
        name: "Fact Sheet (2 pager)",
        link: "Fact+Sheet+(2+pager)",
        type: "pdf"
      },
      {
        name: "Fact Sheet (4 pager)",
        link: "Fact+Sheet+(4+pager)",
        type: "pdf"
      },
    ]
  }),
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "10%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "50%";
      }
      return "50%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    },
    columnsIcons() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      if (this.$vuetify.breakpoint.sm) {
        return 12;
      }
      if (this.$vuetify.breakpoint.md) {
        return 6;
      }
      if (this.$vuetify.breakpoint.lg) {
        return 1.5;
      }
      if (this.$vuetify.breakpoint.xl) {
        return 1.5;
      }
      return 12;
    },
    modalWidth() {
      if (this.$vuetify.breakpoint.xs) {
        return "90%";
      }
      if (this.$vuetify.breakpoint.sm) {
        return "90%";
      }
      if (this.$vuetify.breakpoint.md) {
        return "80%";
      }
      if (this.$vuetify.breakpoint.lg) {
        return "40%";
      }
      if (this.$vuetify.breakpoint.xl) {
        return "40%";
      }
      return "50%";
    }
  },
  methods: {
    toggleVideoDialog() {
      this.showVideoDialog = !this.showVideoDialog;
    },
    goTo(id) {
      const externalLinks = {
        web: "https://www.itsmarta.com",
        facebook: "https://www.facebook.com/MARTAtransit/",
        twitter: "https://twitter.com/MARTAtransit",
        insta: "https://www.instagram.com/marta_explorers/",
        meeting: "https://youtu.be/mhjT1raVEL4",
        factSheet:
          "https://campbellton-files.s3.us-east-2.amazonaws.com/Campbellton+Fact+Sheet+0721.02.V5.pdf"
      };
      window.open(externalLinks[id], "_blank");
    },
    toggleDocuments() {
      this.doctoggled = !this.doctoggled;
    },
    toggleMeetings() {
      this.meetingstoggled = !this.meetingstoggled;
    },
    getFile(fileName, fileType) {
      // adding this in to allow non pdf files, quick fix to revisit later - pc
      if (fileType == "pdf") {
        const fileUrl = `https://campbellton-files.s3.us-east-2.amazonaws.com/${fileName}.pdf`;
        return fileUrl;
      } else {
        return fileName
      }
      // return require(`../../public/static/documentpdfs/${fileName}.pdf`);


    }
  }
};
</script>
<style scoped>
.icon-text {
  font-size: 1.3em;
  padding-top: 0.3em;
}

.icon-link {
  cursor: pointer;
}

#doc-name {
  font-size: 1rem;
}

/* div.slide-content.text-center {
  margin-top: 1;
  padding-top: 1;
} */
</style>
